import { render, staticRenderFns } from "./ProfilesInvoiceSellerTable.vue?vue&type=template&id=72bf8d41&scoped=true"
import script from "./ProfilesInvoiceSellerTable.vue?vue&type=script&lang=js"
export * from "./ProfilesInvoiceSellerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf8d41",
  null
  
)

export default component.exports